import { Button } from '@pets-ui/Button/Button'
import * as stylex from '@stylexjs/stylex'
import { type ReactNode } from 'react'

const styles = stylex.create({
  root: {
    gap: 4,
    alignItems: 'center',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
  },
})

export interface CouponConditionListGridProps {
  children: ReactNode
  goPromotionHref?: string
}

export const CouponConditionListGrid = (props: CouponConditionListGridProps) => {
  const { children, goPromotionHref } = props
  return (
    goPromotionHref
      ? (
        <Button variant="text" component="a" href={goPromotionHref} target="_blank" rootStyle={styles.root}>
          {children}
        </Button>
      )
      : (
        <div {...stylex.props(styles.root)}>
          {children}
        </div>
      )
  )
}
